module.exports = __webpack_public_path__ + "static/media/Antelope.svg";